var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCharts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7108 0H7.28923C3.2635 0 0 3.2635 0 7.28923V35.7108C0 39.7365 3.2635 43 7.28923 43H35.7108C39.7365 43 43 39.7365 43 35.7108V7.28923C43 3.2635 39.7365 0 35.7108 0Z",
    fill: "url(#paint0_linear_130_6012)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_130_6012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8794 18.5835L26.8601 25.7645L38.5283 10.4565L37.3189 9.61084L26.5913 23.6862L17.6554 16.5338L8.96582 27.1477L10.1453 28.0363L17.8794 18.5835Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.07606 34.3998V7.1665H3.58301V35.8332H39.4163V34.3998H5.07606Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_130_6012",
    x1: 0,
    y1: 21.5,
    x2: 43,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06A099"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#189CD9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_130_6012"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.8333,
    height: 28.6667,
    fill: "white",
    transform: "translate(3.58301 7.1665)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharts);
export default __webpack_public_path__ + "static/media/charts.dda8c2e01e4e18c17a343086055d40e2.svg";
export { ForwardRef as ReactComponent };